<template>
  <div class="top margin-top-15 margin-bottom-20 flex">
    <div class="top-left flex flex-align-center">
      <img :src="driverInfo.avatar" class="avatar margin-left-15 margin-right-25" />
      <div>
        <div class="flex flex-align-center margin-bottom-20">
          <span class="margin-right-10 font-18 font-weight">{{ driverInfo.name }}</span>
          <div class="driver-pos pointer flex flex-align-center">
            <span
              class="font font-12 text-eli"
              style="display: inline-block; max-width: 300px"
              @click="situationDetail"
              >司机位置：{{ driverInfo.location }}</span
            >
            <i class="el-icon-refresh-right margin-left-10 color-999 font-16" @click="refresh"></i>
          </div>
        </div>
        <div class="flex flex-align-center">
          <div class="flex flex-col">
            <span class="title margin-bottom-5 font-12 color-999">手机号</span>
            <span class="font-14 color-666">{{ driverInfo.mobilePhone }}</span>
          </div>
          <div class="line"></div>
          <div>
            <div class="flex flex-col">
              <span class="title margin-bottom-5 font-12 color-999">车牌号</span>
              <span class="font-14 color-666">{{ driverInfo.plateNumber }}</span>
            </div>
          </div>
          <div class="line"></div>
          <div>
            <div class="flex flex-col">
              <span class="title margin-bottom-5 font-12 color-999">所属供应商</span>
              <span class="font-14 color-666">{{ driverInfo.merchantName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="top-right padding-15">
      <div class="title margin-bottom-15 flex flex-between flex-align-center">
        <span class="font-weight color-333">今日数据</span>
        <span class="color-666 font-12">数据更新时间 {{ dataUpdateTime }}</span>
      </div>
      <div class="content flex">
        <div class="flex flex-col flex-align-center">
          <span class="color-666 font-14 desc-title">接单数</span>
          <div>
            <span class="font-24 color-333 font-weight margin-right-5">{{
              driverInfo.meetCount || 0
            }}</span>
            <span class="color-999 font-12">单</span>
          </div>
        </div>
        <div class="flex flex-col flex-align-center">
          <span class="color-666 font-14 desc-title">已完成订单数</span>
          <div>
            <span class="font-24 color-333 font-weight margin-right-5">{{
              driverInfo.finishCount || 0
            }}</span>
            <span class="color-999 font-12">单</span>
          </div>
        </div>
        <div class="flex flex-col flex-align-center">
          <span class="color-666 font-14 desc-title">在线时长</span>
          <div>
            <span class="font-24 color-333 font-weight">{{ getHour(driverInfo.onlineTime) }}</span>
            <span class="color-999 font-12 margin-x-5">小时</span>
            <span class="font-24 color-333 font-weight margin-right-5">{{
              getMin(driverInfo.onlineTime)
            }}</span>
            <span class="color-999 font-12">分</span>
          </div>
        </div>
        <div class="flex flex-col flex-align-center">
          <span class="color-666 font-14 desc-title">服务时长</span>
          <div>
            <span class="font-24 color-333 font-weight">{{ getHour(driverInfo.serviceTime) }}</span>
            <span class="color-999 font-12 margin-x-5">小时</span>
            <span class="font-24 color-333 font-weight margin-right-5">{{
              getMin(driverInfo.serviceTime)
            }}</span>
            <span class="color-999 font-12">分</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
import { inject, ref, watch } from '@vue/composition-api';
import { driverDataJob } from '@/api/data-analysis';
import { Message } from 'element-ui';
import { formatDate } from '../util/format-date';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const driverInfo = inject('driverInfo');
  const driverId = inject('driverId');
  const freshLoading = ref(false);
  const dataUpdateTime = ref('');
  watch(driverInfo, (newVal, oldVal) => {
    if (JSON.stringify(newVal) === '{}') {
      return;
    }
    const {
      year,
      month,
      day,
      hours,
      minutes,
      seconds
    } = formatDate(new Date(driverInfo.value.updateTime));
    dataUpdateTime.value = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  });
  const getHour = s => {
    if (!s) {
      return 0;
    }
    const result = Math.floor(s / 3600);
    if (result) {
      return result;
    }
    return 0;
  };
  const getMin = s => {
    if (!s) {
      return 0;
    }
    const result = s % 3600;
    if (result) {
      return Math.round(result / 60);
    }
    return 0;
  };
  const situationDetail = () => {
    emit('situationDetail', driverInfo.value);
  };
  const refresh = async () => {
    if (freshLoading.value) {
      Message.warning('刷新中,请稍后...');
      return;
    }
    try {
      freshLoading.value = true;
      const {
        code
      } = await driverDataJob({
        driverId: driverId.value
      });
      if (code !== 0) {
        return;
      }
      emit('refreshData');
    } catch (error) {} finally {
      freshLoading.value = false;
    }
  };
  return {
    driverInfo,
    dataUpdateTime,
    getHour,
    getMin,
    situationDetail,
    refresh
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .top {
    height: 158px;
    background: #fff;
    padding: 15px 20px;
    border-radius: 8px;
    box-sizing: border-box;
    .top-left {
      min-width: 550px;
      margin-right: 43px;
    }
    .top-right {
      width: calc(100% - 550px);
      height: 128px;
      background: #f6f6f6;
      border-radius: 8px;
      box-sizing: border-box;

      .content {
        justify-content: space-around;
        .desc-title {
          margin-bottom: 8px;
        }
      }
    }
  }
  .avatar {
    width: 65px;
    height: 65px;
    border-radius: 50%;
  }
  .driver-pos {
    height: 22px;
    background: #eefbf2;
    border-radius: 6px;
    padding: 2px 10px;
    .font {
      color: #22c655;
      font-weight: 500;
    }
  }
  .line {
    border-left: 1px solid #e6e6e6;
    width: 1px;
    height: 31px;
    margin: 0 15px;
  }
</style>
